var React = require('react');

function CrossYellow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m221.09 202.5 42.54-42.5a11.44 11.44 0 0 0 -16.18-16.18l-42.54 42.54-42.53-42.54a11.44 11.44 0 0 0 -16.19 16.18l42.54 42.54-42.54 42.46a11.44 11.44 0 0 0 16.19 16.18l42.53-42.54 42.54 42.54a11.44 11.44 0 0 0 16.18-16.18z","fill":"#f9bc5e"}));
}

CrossYellow.defaultProps = {"viewBox":"0 0 410 405"};

module.exports = CrossYellow;

CrossYellow.default = CrossYellow;
